import React from "react";
import "./experiencePage.css";

const ExperiencePage = () => {
	return (
		<div className="experience-page">
			<h1>My Experience</h1>
			<div className="experience-item">
				<div className="experience-content">
					<h2>Internship over at Rural Senses, a startup</h2>
					<p>
						Worked as a Full-Stack developer on already existing
						code alongside other developers.
					</p>
					<p>
						- Frontend being ReactJS with adding new features and
						updating existing features.
					</p>
					<p>
						- Backend being Flask Python, learning Flask and
						updating the backend with Commands and Decorators.
					</p>
				</div>
				<div>
					<img
						src={require("../../assets/experience images/Rural Senses.jpg")}
						alt="Rural Senses Logo"
						loading="lazy"
					/>
				</div>
			</div>
			<div className="experience-item">
				<div className="experience-content">
					<h2>Attended a Full-Stack Bootcamp at AppleSeeds</h2>
					<p>
						- Intensive 6-months, 720 hours training program that
						encourages self-led learning as well as group projects
						that simulate real-world development teams.
					</p>
					<p>
						- Learning and applying frontend skills such as HTML,
						CSS, JavaScript, React and backend skills as NodeJs and
						MongoDB database.
					</p>
				</div>
				<div>
					<img
						src={require("../../assets/experience images/Appleseeds.jpg")}
						alt="Appleseeds Logo"
						loading="lazy"
					/>
				</div>
			</div>
			<div className="experience-item">
				<div className="experience-content">
					<h2>Studied at the Italian School, Haifa.</h2>
					<p>
						- Majored in Computer Science with 10 units and Physics
						with 5 units.
					</p>
					<p>
						- Graduated with a final score of 92 with the Computer
						Science Bagrut, 100 with the Computer Science final
						project and 92 with the Physics Bagrut.
					</p>
				</div>
				<div>
					<img
						src={require("../../assets/experience images/Italian School.jpeg")}
						alt="Italian School Logo"
						loading="lazy"
					/>
				</div>
			</div>
			<div className="experience-item">
				<div className="experience-content">
					<h2>
						Attended an Entrepreneurship training course at JA
						Worldwide.
					</h2>
					<p>
						- Completed the initial training and got experience in
						the entrepreneur business world.
					</p>
					<p>
						- Worked with fellow classmates to develop a new idea to
						sell which ended up being a self watering pot for your
						in-house plants.
					</p>
				</div>
				<div>
					<img
						src={require("../../assets/experience images/JA Worldwide.jpg")}
						alt="JA Worldwide Logo"
						loading="lazy"
					/>
				</div>
			</div>
			<div className="experience-item">
				<div className="experience-content">
					<h2>
						Attended an Android App Development Course by John Bryce
					</h2>
					<p>
						- Learned Java and how to use the Android Studio
						Application to make Android apps.
					</p>
					<p>
						- Created a movies app that pulls data from an online
						database with the ability to search and rate movies.
					</p>
				</div>
				<div>
					<img
						src={require("../../assets/experience images/John Bryce.jpg")}
						alt="John Bryce Logo"
						loading="lazy"
					/>
				</div>
			</div>
		</div>
	);
};

export default ExperiencePage;
